/* eslint-disable @typescript-eslint/no-explicit-any */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Template, TemplateState } from '../interfaces/reducersInterfaces';
import { RootState } from '../store';


const initialState: TemplateState = {
  templates: [],
  selectedTemplate: null,
  templateVariables: {},
  isPreviewOpen: false,
  templateCount: 0,
  loading: false,
  error: null
};

const parseTemplateFormat = (format: string) => {
  if (!format) return [];
  const variables: { type: string, count: number }[] = [];
  const formatParts = format.slice(1, -1).split(',').map(part => part.trim());
  
  formatParts.forEach(part => {
    const [type, count] = part.split(':');
    variables.push({ type: type.trim(), count: parseInt(count) });
  });
  
  return variables;
};

const templateSlice = createSlice({
  name: 'template',
  initialState,
  reducers: {
    setTemplates: (state, action: PayloadAction<Template[]>) => {
      state.templates = action.payload;
      state.templateCount = action.payload.length;
    },
    setSelectedTemplate: (state, action: PayloadAction<Template | null>) => {
      state.selectedTemplate = action.payload;
      if (action.payload) {
        const newVariables: { [key: string]: string } = {};

        // Initialize body variables from the component
        const bodyComponent = action.payload.components.components.find(
          comp => comp.type === 'BODY'
        );
        if (bodyComponent?.example?.body_text?.[0]) {
          bodyComponent.example.body_text[0].forEach((_, index) => {
            newVariables[`b_${index + 1}`] = '';
          });
        }

        // Initialize media variables from header component
        const headerComponent: any = action.payload.components.components.find(
          comp => comp.type === 'HEADER'
        );
        if (headerComponent?.format) {
          const format = headerComponent.format.toLowerCase();
          if (['image', 'video', 'document'].includes(format)) {
            newVariables['m_1'] = '';
          }
        }

        // Initialize website variables from template_formate
        if (action.payload.template_formate) {
          const formatVariables = parseTemplateFormat(action.payload.template_formate);
          formatVariables.forEach(({ type, count }) => {
            switch (type) {
              case 'vw':
                // Only handle up to 2 website variables
                for (let i = 1; i <= Math.min(count, 2); i++) {
                  newVariables[`vw_${i}`] = '';
                }
                break;
              case 'm':
                // If media is specified in format and header exists
                if (headerComponent?.format) {
                  const format = headerComponent.format.toLowerCase();
                  if (['image', 'video', 'document'].includes(format)) {
                    newVariables['m_1'] = '';
                  }
                }
                break;
            }
          });
        }

        state.templateVariables = newVariables;
      } else {
        state.templateVariables = {};
      }
    },
    updateTemplateVariable: (
      state,
      action: PayloadAction<{ key: string; value: string }>
    ) => {
      state.templateVariables[action.payload.key] = action.payload.value;
    },
    setPreviewOpen: (state, action: PayloadAction<boolean>) => {
      state.isPreviewOpen = action.payload;
    }
  }
});

export const {
  setTemplates,
  setSelectedTemplate,
  updateTemplateVariable,
  setPreviewOpen
} = templateSlice.actions;

export const selectTemplates = (state: RootState) => state.template.templates;
export const selectSelectedTemplate = (state: RootState) => state.template.selectedTemplate;
export const selectTemplateVariables = (state: RootState) => state.template.templateVariables;
export const selectIsPreviewOpen = (state: RootState) => state.template.isPreviewOpen;
export const selectTemplateCount = (state: RootState) => state.template.templateCount;

export default templateSlice.reducer;




